
































import { Vue, Component, Prop } from "vue-property-decorator";
import NewInputDialog from "./NewInputDialog.vue";
import { TemplateResource } from "@/store/template/types";
import { FormResource } from "@/store/form/types";
import TruncatedText from "../TruncatedText.vue";

@Component({
  components: {
    TruncatedText
  }
})
export default class FormTile extends Vue {
  // Vuex store with lightweight typed wrapper
  readonly store = this.$store.direct;
  // Component Attributes
  @Prop() template!: TemplateResource;

  get request() {
    return this.store.state.request.selected;
  }

  get form() {
    if (this.request) {
      return this.request.relationships.forms.data.find(form => {
        return form.relationships.template.data.id == this.template.id;
      });
    }
    return undefined;
  }

  get inputs() {
    return this.template.attributes.sections
      .map(section => {
        return section.inputs;
      })
      .flat().length;
  }
}
